import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { pageMeta } from "@/lib/seo/meta";
import { TOOL_CACHE_HEADERS } from "@/lib/seo/headers";

const MergePdfView = lazy(() => import("@/features/merge-pdf/view"));

export const Route = createFileRoute("/merge")({
  head: () =>
    pageMeta({
      title: "Merge PDF",
      description:
        "Combine any number of PDFs into one file. Drag to reorder, then download. Free, in your browser.",
      path: "/merge",
      keywords: "merge pdf, combine pdf, join pdf, online, free",
    }),
  headers: () => TOOL_CACHE_HEADERS,
  component: () => (
    <Suspense fallback={null}>
      <MergePdfView />
    </Suspense>
  ),
});
